import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Adds a new ledger name for an entity.
 * POST api/Onboarding/update-individual-ledger
 */
export const updateIndividualLedgerAction = async ({
  entityPrimaryId,
  entityId,
  ledgerName,
  entityName,
  createdBy,
}) => {
  try {
    const response = await apiClient.post(
      ATP_API_URL.UPDATE_INDIVIDUAL_LEDGER,
      {
        entityPrimaryId: entityPrimaryId || 0,
        entityId: entityId || "",
        ledgerName: ledgerName || "",
        entityName: entityName || "",
        createdBy: createdBy || "",
      },
    );

    if (response?.status === 200 && response.data) {
      const { success, message } = response.data;
      if (success) {
        return {
          success: true,
          message: message || "Ledger added successfully",
        };
      }
      // API returned success:false (e.g. "Ledger Name Already Exists.")
      return { success: false, message: message || "Failed to add ledger" };
    }
    return { success: false, message: "Failed to add ledger" };
  } catch (error) {
    console.error("[UpdateIndividualLedger] error:", error);
    return {
      success: false,
      message: error.message || "Failed to add ledger",
    };
  }
};
